import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'fallbackTranslate',
  // Impure so a label can update when the translation file arrives, but each
  // binding keeps the resolved string and skips TranslateService after that.
  pure: false,
})
export class FallbackTranslatePipe implements PipeTransform {
  private cachedKey = '';
  private cachedValue: string = null;

  constructor(private translateService: TranslateService) {
    this.translateService.onLangChange.subscribe(() => {
      this.cachedKey = '';
      this.cachedValue = null;
    });
    this.translateService.onTranslationChange.subscribe(() => {
      this.cachedKey = '';
      this.cachedValue = null;
    });
  }

  transform(key?: string, fallbackValue?: string): string {
    if (!key) return '';
    if (key === this.cachedKey && this.cachedValue != null) {
      return this.cachedValue;
    }
    let newValue = key;
    const lastIndex = key.lastIndexOf('.');
    if (lastIndex !== -1) {
      newValue = key.substring(lastIndex + 1);
    }
    newValue = newValue.replace(/_/g, ' ');
    fallbackValue = fallbackValue ? fallbackValue : newValue;

    const translation = this.translateService.instant(key);
    if (translation == null || translation === '' || translation === key) {
      return fallbackValue;
    }
    this.cachedKey = key;
    this.cachedValue = translation;
    return translation;
  }
}
